import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  ResponseModels_Usages_V3_UsagesModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetUsagesV4 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
  interval?: string;
  aggregation?: string;
  start?: string;
  end?: string;
  extrapolate?: boolean;
  addWeather?: boolean;
  addPreviousYear?: boolean;
  addBudget?: boolean;
};
/**
 * Usage V4 should be identical with usage V3 but it should consume the new V4 service.
We are implementing a new endpoint to enable our clients run experiments comparing V4 and V3
TODO we will migrate this endpoint to V4 when it's available, at the moment we expose the new endpoint to enable development
 * 
 * @returns ResponseModels_Usages_V3_UsagesModel Success
 */
export function getUsagesV4(
  {
    businessUnit,
    label,
    customerId,
    accountId,
    interval,
    aggregation,
    start,
    end,
    extrapolate,
    addWeather,
    addPreviousYear,
    addBudget,
  }: GetUsagesV4,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Usages_V3_UsagesModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/v4/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/usages`,
      query: { interval, aggregation, start, end, extrapolate, addWeather, addPreviousYear, addBudget },
      errors: { 400: 'Bad Request', 404: 'Not Found', 500: 'Server Error' },
    },
    requestConfig,
  );
}
